import {ReactComponent as CloseIcon} from "./close.svg";

const Closeicon = () => {
    return (
        <div className='close_button'><CloseIcon className='icon' /></div>
    )
}
export default Closeicon
